import { rsBranding } from "@resourcehub/resourcehub-assets";

export default ({ strings }) => ({
    visible: true,
    image: {
        asset_static: rsBranding.rsLogoBlackSvg,
        height: "40px",
        width: "93px",
        alt: strings.nav_primary_logo_alt
    },
    link: {
        destination: "/",
        external: false,
        new_window: false
    }
});
